module.exports = __webpack_public_path__ + "img/builder-29.4fa9e30e.jpg";